<template>
  <div class="notification-activity_icon">
    <FontIcon :class="`icon-${name}`" />
  </div>
</template>

<script lang="ts" setup>
import FontIcon from '@/components/inputs/icon/font-icon/FontIcon.vue';

defineProps({
  name: {
    type: String,
    required: true,
  },
});
</script>
